class IntersectionFun {
  constructor(name = "img") {
    this.name = name;
  }

  ob() {
    const ob = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            const img = entry.target;
            img.src = img.dataset.realSrc;

            // cancel listen
            ob.unobserve(img);
          }
        }
      },
      {
        threshold: 0,
      }
    );

    const imgs = document.querySelectorAll(`${this.name}[data-real-src]`);
		
    imgs.forEach((img) => {
      ob.observe(img);
    });
  }
}